'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.div.withConfig({
  componentId: 's1l15ya-0'
})(['position:absolute;left:0;top:5px;background:#fff;box-shadow:0 2px 5px rgba(0,0,0,0.15);z-index:1;']);